export class InsuranceContributionRequest {
    public retailerCode: string;
    public saleDate: string;
    public handoverDate: string;
    public vin: string;
    public email: string;
    public consent: boolean;
    public renewalDate: string;
    public vrn: string;
    public make: string;
    public model: string;
    public newVehicle?: boolean;
}
